import React from "react";
import {TextField, TextFieldState} from './TextField'

export class PasswordField extends TextField {
    getFieldType(): string {
        return "password";
    }

    getErrorText(): string {
        let error = super.getErrorText();
        if (error) {
            return error;
        }

        if (this.hasValue()) {
            let strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,21}$/g;
            if (!strongRegex.test(this.getValue())) {
                return "Password must be between 8 and 21 characters long and contain at least 1 numeric, 1 lowercase and 1 uppercase letter.";
            }
        }

        return null;
    }
}